import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { useAnalytics } from 'modules/reviews/pages/performance/Show/Analytics/analyticsContext'
import type AnalyticResult from 'modules/reviews/store/models/AnalyticResult'

import QuestionHeadCell from './_QuestionHeadCell'
import ReviewRow from './_ReviewRow'
import TableOptions from './_TableOptions'

const ANONYMOUS_PLACEHOLDER = '-'
interface Props {
  analyticResult: AnalyticResult
  formName: string
}

const RawResult = ({ analyticResult, formName }: Props) => {
  const { cycle } = useAnalytics()

  return (
    <Table
      style={{ minWidth: '100%', width: 'min-content' }}
      options={() => <TableOptions formName={formName} keyName={analyticResult.typeOfReviewer} />}
    >
      <Table.Head>
        <Table.Row>
          <Table.HeadCell width={180}>
            {i18n.t('surveys.review.analytics.table.reviewee')}
          </Table.HeadCell>
          <Table.HeadCell width={180}>
            {i18n.t('surveys.review.analytics.table.reviewer')}
          </Table.HeadCell>
          {Array.from(analyticResult.questions).map((question) => (
            <QuestionHeadCell key={question.id} label={question.label} />
          ))}
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {analyticResult.questionGroupsInCycle(cycle).map((questionGroup) => {
          const targetFullName = users.get(questionGroup.target_id)?.fullName() || '-'

          const participantFullName = users.get(questionGroup.participant_id)?.fullName()

          return (
            <ReviewRow
              key={questionGroup.id}
              targetFullName={targetFullName}
              participantFullName={participantFullName || ANONYMOUS_PLACEHOLDER}
              answers={questionGroup.answers}
              questionIds={analyticResult.questionIds}
            />
          )
        })}
      </Table.Body>
    </Table>
  )
}

export default observer(RawResult)
